import { type ChangeEvent, type FC, type FocusEvent, useEffect, useId, useState } from 'react';
import { LOBBY_MESSAGE_MAX_LENGTH } from '../../helpers/constants';
import { useLobbyMessageHandler } from '../../hooks';
import type { LobbyRoomTabProps } from '../../types';

const LobbyRoomTab: FC<LobbyRoomTabProps> = ({
  selectedMeetingData,
  isUpdating,
  updateMeetingData,
}) => {
  const [lobbyMessage, setLobbyMessage] = useState(selectedMeetingData.lobbyMessage);
  const messageInputId = useId();
  const { handleLobbyMessageCommit } = useLobbyMessageHandler({ updateMeetingData });

  useEffect(() => {
    setLobbyMessage(selectedMeetingData.lobbyMessage);
  }, [selectedMeetingData.lobbyMessage]);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setLobbyMessage(event.target.value);
  };

  const handleBlur = (event: FocusEvent<HTMLTextAreaElement>) => {
    if (event.target.value !== selectedMeetingData.lobbyMessage) {
      void handleLobbyMessageCommit(event.target.value);
    }
  };

  return (
    <div className="personal-meetings-modal__tab-content">
      <div className="personal-meetings-modal__form-box">
        <div className="personal-meetings-modal__form-field">
          <label className="personal-meetings-modal__field-label" htmlFor={messageInputId}>
            Lobby room message
          </label>
          <textarea
            id={messageInputId}
            className="personal-meetings-modal__lobby-msg"
            maxLength={LOBBY_MESSAGE_MAX_LENGTH}
            value={lobbyMessage}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Host will join the meeting soon."
            disabled={isUpdating}
          />
          <div className="personal-meetings-modal__lobby-msg-counter">
            {lobbyMessage.length}/{LOBBY_MESSAGE_MAX_LENGTH}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LobbyRoomTab;
